/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const s = (t, e) => {
  Object.keys(e).forEach((o) => {
    t.append(o, e[o]);
  });
}, p = (t, e, o) => {
  let n = new FormData();
  return s(n, o), t.forEach((a) => {
    const r = a.getRawFile ? a.getRawFile() : "";
    r ? n.append(e, r, a.name) : n.append(e, r);
  }), n;
}, c = (t, e, o) => {
  let n = new FormData();
  return s(n, o), t.forEach((a) => {
    n.append(e, a);
  }), n;
}, l = (t, e) => ({
  headers: t,
  responseType: e.responseType,
  withCredentials: e.withCredentials
}), u = (t) => {
  let e = {};
  return Object.keys(t).forEach((o) => {
    e[o] = t[o];
  }), e;
}, d = (t) => {
  const { data: e, config: o, ...n } = t;
  return {
    response: e,
    ...n
  };
}, i = {
  populateClientFormData: s,
  populateUploadFormData: p,
  populateRemoveFormData: c,
  populateRequestOptions: l,
  cloneRequestHeaders: u,
  convertAxiosResponse: d
};
export {
  i as default
};
